
import {getFirstNowLastDay} from "@/api/date";

const columnList: Array<column> = [
    {
        prop: "purchaes_number",
        label: "单据编号",
        width: 164,
    },
    {
        prop: "purchase_time_text",
        label: "单据日期",
        width: 75,
    },
    {
        prop: "purchase_type_name",
        label: "采购类型",
        width: 75,
    },
    {
        prop: "employee",
        label: "采购员",
        width: 75,
    },
    {
        prop: "supplier",
        label: "供应商",
        width: 75,
    },
    {
        prop: "mountings_type_p_name",
        label: "配件分类",
        width: 75,
    },
    {
        prop: "parts_name",
        label: "配件名称",
        width: 75,
    },
    {
        prop: "specification",
        label: "规格",
        width: 75,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 75,
    },
    {
        prop: "price",
        label: "采购单价",
        width: 75,
    },
    {
        prop: "member",
        label: "数量",
        width: 75,
    },
    {
        prop: "purchaes_price",
        label: "采购金额",
        width: 75,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getPurchaseDetail,
    getPurchaseExport,
    getPurchaseTable,
    getSupplierList,
    getSupplierTotalList
} from "@/api/http";
import { column } from "@/assets/types/common";
import { ElLoading } from 'element-plus';

export default defineComponent({
    name: "PurchaseDetailed",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["采购明细"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            totalSum = ref({

            } as any),
            loading = ref(true),
            total = ref(0),
            headClass = inject("headClass"),
            screenParameter: any = {
                page: currentPage.value,
                limit: pageSize.value,
                time_type: "",
                start_time: "",
                end_time: "",
                purchase_type: "",
                status: "",
                supplier_id: "",
                employee_id: "",
                search: "",
            },
            screen = reactive({
                search: "",
                time: getFirstNowLastDay(),
                service: null,
            }),
            dialogFormVisible = ref(false),
            dialogTitle = "",
            supplierList = ref([] as Array<any>),
            getTableData = (): void => {
                loading.value = true;
                let start_time = screen.time?Math.floor(new Date(screen.time[0]).getTime()/1000):"";
                let end_time = screen.time ?Math.floor((new Date(screen.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                screenParameter["page"] = currentPage.value;
                screenParameter["pagesize"] = pageSize.value;
                screenParameter["start_time"] = start_time;
                screenParameter["end_time"] = end_time;
                console.log(screenParameter);
              getPurchaseDetail(screenParameter).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                total.value = res?.content?.total || 0;
                totalSum.value.total_price = res?.content?.total_price;
                totalSum.value.total_member = res?.content?.total_member;
                });
            },
            handleSizeChange = (size: number): void => {
              pageSize.value = size;
              getTableData();
            },
            handleCurrentChange = (page: number): void => {
              currentPage.value = page;
              getTableData();
            },
            getSummaries = (param:any) => {
              const { columns, data } = param;
              const sums: any = [];
              const propArr = [
                "member",
                "purchaes_price"
              ];
              columns.forEach((column: any, index: number) => {
                if (index === 0) {
                  sums[index] = "合计";
                  return;
                }
                const values = data.map((item: any) =>
                    Number(item[column.property])
                );
                if (
                    propArr.findIndex((item: any) => {
                      return item == column.property;
                    }) > -1
                ) {
                  // 增加合计项
                  if (column.property == "member") {
                    sums[index] = totalSum.value.total_member;
                  } else if (column.property == "purchaes_price") {
                    sums[index] = totalSum.value.total_price;
                  }

                } else {
                  sums[index] = "";
                }
              });
              return sums;
            },
            getsupplierList = (): void => {
                loading.value = true;
                getSupplierTotalList({status:1}).then((res: any) => {
                    supplierList.value = res?.content?.list || [];
                });
            },

            selectChange = (e: number): void => {
                getTableData();
            },
            searchChange = (e:string) => {
              if (!e){
                delete screenParameter["search"];
              } else {
                screenParameter["search"] = e;
              }
              getTableData();
            },
            exportChange = () => {
              const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
              });
              getPurchaseExport(screenParameter).then((res: any) => {
                //tableData.value = res?.content?.list || [];
                loading.close();
                const url = res.content;
                window.open(url);

              });
            },
            screenChange = (
                e: string | Array<Date> | Array<number>,
                key: string
            ): void => {
                // if (!e) {
                //     if (key == "time") {
                //         delete screenParameter["start_time"];
                //         delete screenParameter["end_time"];
                //     } else {
                //         delete screenParameter[key];
                //     }
                // } else {
                //     if (key == "time") {
                //         screenParameter["start_time"] = Math.floor((e[0] as Date).getTime()/1000);
                //         screenParameter["end_time"] = Math.floor(((e[1] as Date).getTime()+24*60*60*1000-1)/1000);
                //     } else {
                //         screenParameter[key] = e;
                //     }
                // }
                if (e){
                    getTableData();
                }
            };

        onMounted(() => {
            getTableData();
            getsupplierList();
        });

        return {
            columnList,
            tableData,
            loading,
            getsupplierList,
            supplierList,
            dialogFormVisible,
            dialogTitle,
            headClass,
            screen,
            screenChange,
            screenParameter,
            selectChange,
          searchChange,
          exportChange,
          handleSizeChange,
          handleCurrentChange,
          total,
          getSummaries,
          totalSum
        };
    },
});
